import {
  CATEGORY_FACET_ID,
  PRICE_PSEUDO_FACET_ID,
  PRIORITIZE_THIS_JOB,
} from "../constants";

const enableBrowserHistoryNavigation = (action) => {
  window.onpopstate = () => action();
};

const listenerAction = (selector, action) => (e) => {
  let eventHappenedOutsideOfSelector = true;
  Array.from(document.querySelectorAll(selector)).forEach((el) => {
    if (el.contains(e.target)) {
      eventHappenedOutsideOfSelector = false;
    }
  });

  if (eventHappenedOutsideOfSelector) {
    action();
  }
};

const takeActionWhenEventHappensOutsideOfSelector = ({
  event,
  action,
  remove,
}) => {
  if (remove) {
    document.body.removeEventListener(event, action);
  } else {
    document.body.addEventListener(event, action);
  }
};

const setScreenStateOnWindowResize = (action) => $(window).resize(action);

const pushState = (params) => `?${$.param(params)}`;

const checkIfOnlyCategoryFilterIsSelected = ({ filters }) => {
  let onlyCategoryFilterIsSelected = true;
  if (filters) {
    Object.keys(filters).forEach((facetId) => {
      if (Number(facetId) !== CATEGORY_FACET_ID) {
        onlyCategoryFilterIsSelected = false;
      }
    });
  }
  return onlyCategoryFilterIsSelected;
};

const displayPriceRanges = ({ dataFromServer }) => {
  let priceFacetName = null;
  if (dataFromServer.min_price !== null && dataFromServer.max_price === null) {
    priceFacetName = `> $${dataFromServer.min_price}`;
  }

  if (dataFromServer.min_price === null && dataFromServer.max_price !== null) {
    priceFacetName = `< $${dataFromServer.max_price}`;
  }

  if (dataFromServer.min_price !== null && dataFromServer.max_price !== null) {
    priceFacetName = `$${dataFromServer.min_price} - $${dataFromServer.max_price}`;
  }

  if (priceFacetName && dataFromServer.facet_params_name) {
    dataFromServer.facet_params_name.push({
      facet_id: PRICE_PSEUDO_FACET_ID,
      name: priceFacetName,
    });
  }
};

const findLowestChildren = (children) => {
  const checkIfChildrenExist = (filter) =>
    filter.children && filter.children.length > 0;

  let lowestChildren = children;
  let isThislowestLevel = true;
  for (let i = 0; i < children.length; i += 1) {
    if (checkIfChildrenExist(children[i])) {
      lowestChildren = children[i].children;
      isThislowestLevel = false;
    }
  }

  if (isThislowestLevel) {
    return lowestChildren;
  }

  return findLowestChildren(lowestChildren);
};

const setCategoryUtilities = ({ filters }) => {
  let categoryList = [];
  let categoryTargetFilter = {};
  let categoryParentFilterExists = false;

  filters.forEach((filter) => {
    if (filter.facet.id === CATEGORY_FACET_ID) {
      categoryList = findLowestChildren(filter.active_facet_tags);
      categoryTargetFilter = filter.target_facet_tag;
      categoryParentFilterExists =
        categoryTargetFilter &&
        Object.keys(categoryTargetFilter).length > 0 &&
        categoryTargetFilter.parent_id !== undefined &&
        categoryTargetFilter.parent_id !== null &&
        categoryTargetFilter.parent_id !== categoryTargetFilter.id;
    }
  });

  return {
    categoryList,
    categoryTargetFilter,
    categoryParentFilterExists,
  };
};

const isAnyMultiSelectableFilterSelected = ({
  multiSelectableFilter,
  onlyCategoryFilterIsSelected,
}) =>
  multiSelectableFilter !== "" &&
  multiSelectableFilter !== null &&
  !onlyCategoryFilterIsSelected;

const onlyOneMultiSelectableFilterExists = ({ filters }) =>
  Object.keys(filters).length === 2;

const multipleMultiSelectableFiltersExist = ({ filters }) =>
  Object.keys(filters).length > 2;

const isPriceFilterSelected = ({ dataFromServer }) =>
  dataFromServer.min_price !== null || dataFromServer.max_price !== null;

const isLowestCategoryLevelSelected = ({ categoryUtilities }) =>
  categoryUtilities.categoryList.length === 1 &&
  categoryUtilities.categoryParentFilterExists &&
  // this condition excludes denim depot case
  // when there is only one lowest level active facet tag for category
  // but the target is its parent,
  // then you need to show the lowest level active facet tag
  // and NOT replace with the list one level higher.
  categoryUtilities.categoryList[0].id ===
    categoryUtilities.categoryTargetFilter.id;

const replaceCounts = ({ list, listWithCounts }) => {
  if (listWithCounts) {
    if (listWithCounts.length === 0) {
      list.forEach((filter) => {
        filter.count = 0;
      });
    } else {
      list.forEach((filter) => {
        let newCount = 0;
        listWithCounts.forEach((filterWithCounts) => {
          if (filter.id === filterWithCounts.id) {
            newCount = filterWithCounts.count;
          }
        });
        filter.count = newCount;
      });
    }
  }

  return list;
};

// jobId is setTimeoutId when clicking multi-selectable filters
// jobId is -1 when removing a filter or clearing filters/price
// (ALWAYS PRIORITIZE THIS JOB)
// jobId is -2 when resetting or sliding category filter
// jobId for the all the other jobs will be null
const isJobNotCurrent = ({ jobId, currentJobId }) =>
  // usually, if jobId is null, it indicates the job is current
  (jobId && Number(jobId) !== currentJobId) ||
  // but, if current jobId is -1,
  // job is not current even though jobId is null
  // and we need to abort ongoing jobs and prioritize -1 job
  (currentJobId === PRIORITIZE_THIS_JOB && Number(jobId) !== currentJobId);

const constructParams = ({
  facets = {},
  minPrice = NaN,
  maxPrice = NaN,
  term = null,
  brand_id = {},
}) => {
  const params = {
    facets,
    price: {
      min: minPrice,
      max: maxPrice,
    },
    term,
    brand_id,
    react_ajax_request: true,
  };

  return params;
};

// THIS HELPER FUNCTION IS NOT BEING USED
// AS WE DO NOT USE current_facet_id param ANYMORE
const updateCurrentFacetId = ({
  facets = {},
  currentFacetId = "",
  facetIdToBeCleared = null,
  facetIdToBeUpdated = null,
}) => {
  let updatedCurrentFacetId = "";

  if (facetIdToBeCleared) {
    if (Number(facetIdToBeCleared) !== Number(currentFacetId)) {
      updatedCurrentFacetId = currentFacetId;
    } else if (Object.keys(facets).length > 1) {
      Object.keys(facets).forEach((facetId) => {
        if (Number(facetId) !== CATEGORY_FACET_ID) {
          updatedCurrentFacetId = facetId;
        }
      });
    }
  }

  if (facetIdToBeUpdated) {
    updatedCurrentFacetId = facetIdToBeUpdated;
    if (
      Number(facetIdToBeUpdated) !== Number(currentFacetId) ||
      (Number(facetIdToBeUpdated) === Number(currentFacetId) &&
        facets[facetIdToBeUpdated].length > 0)
    ) {
      updatedCurrentFacetId = currentFacetId;
    }

    if (
      Number(facetIdToBeUpdated) === Number(currentFacetId) &&
      facets[facetIdToBeUpdated].length === 0 &&
      Object.keys(facets).length > 2
    ) {
      Object.keys(facets).forEach((facetId) => {
        if (
          Number(facetId) !== CATEGORY_FACET_ID &&
          Number(facetId) !== Number(currentFacetId)
        ) {
          updatedCurrentFacetId = facetId;
        }
      });
    }
  }

  return updatedCurrentFacetId;
};

const findFilterIndex = ({ facet = [], filterId = 0 }) => {
  // This is necessary as the filterId can be either string or number
  const filterIndex =
    facet.indexOf(filterId.toString()) === -1
      ? facet.indexOf(filterId)
      : facet.indexOf(filterId.toString());

  return filterIndex;
};

const reorderCategoryFilter = (facetFilters, isMobile) => {
  let categoryFilterIndex = null;
  for (let i = 0; i < facetFilters.length; i++) {
    if (facetFilters[i].facet.id === CATEGORY_FACET_ID) {
      categoryFilterIndex = i;
      break;
    }
  }

  if (categoryFilterIndex) {
    const firstFilter = facetFilters[0];
    facetFilters[0] = facetFilters[categoryFilterIndex];
    facetFilters[categoryFilterIndex] = firstFilter;
  }

  return facetFilters;
};

const filterApplied = (props) =>
  (props.min_price && !isNaN(props.min_price)) ||
  (props.max_price && !isNaN(props.max_price)) ||
  Object.keys(props.facet_params).length > 0;

const utility = {
  enableBrowserHistoryNavigation,
  takeActionWhenEventHappensOutsideOfSelector,
  setScreenStateOnWindowResize,
  pushState,
  checkIfOnlyCategoryFilterIsSelected,
  displayPriceRanges,
  findLowestChildren,
  setCategoryUtilities,
  isAnyMultiSelectableFilterSelected,
  onlyOneMultiSelectableFilterExists,
  multipleMultiSelectableFiltersExist,
  isPriceFilterSelected,
  isLowestCategoryLevelSelected,
  replaceCounts,
  isJobNotCurrent,
  constructParams,
  updateCurrentFacetId,
  findFilterIndex,
  listenerAction,
  reorderCategoryFilter,
  filterApplied,
};

export default utility;
